import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgMixed = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.60159 10.7967C5.24549 10.7967 5.81785 10.5821 6.31866 10.2244C6.46175 10.0813 6.81947 10.1528 6.96256 10.3675C7.1772 10.5821 7.17719 10.9398 6.89102 11.1545C6.24711 11.5837 5.46012 11.8699 4.60159 11.8699C3.52841 11.8699 2.52679 11.4407 1.81134 10.7252C1.09589 10.0098 0.666626 9.00813 0.666626 7.93496C0.666626 6.86179 1.09589 5.86016 1.81134 5.14472C2.52679 4.42927 3.52841 4 4.60159 4C5.67476 4 6.67638 4.42927 7.32028 5.14472L9.82435 7.64878C10.039 7.86341 10.039 8.22114 9.82435 8.43577C9.7528 8.50732 9.60972 8.57886 9.46663 8.57886C9.32354 8.57886 9.18045 8.50732 9.1089 8.43577L6.60484 5.93171C6.10402 5.35935 5.38858 5.07317 4.60159 5.07317C3.88614 5.07317 3.17069 5.43089 2.59833 5.93171C2.02598 6.43252 1.7398 7.14797 1.7398 7.93496C1.7398 8.72195 2.09752 9.36585 2.59833 9.93821C3.09915 10.5106 3.81459 10.7967 4.60159 10.7967ZM11.3983 4C12.4715 4 13.4731 4.42927 14.1886 5.14472C14.904 5.86016 15.3333 6.86179 15.3333 7.93496C15.3333 9.00813 14.904 10.0098 14.1886 10.7252C13.4731 11.4407 12.4715 11.8699 11.3983 11.8699C10.3252 11.8699 9.32354 11.4407 8.60809 10.7252L6.10402 8.22114C5.88939 8.0065 5.88939 7.64878 6.10402 7.43415C6.31866 7.21951 6.67638 7.21951 6.89102 7.43415L9.39508 9.93821C9.89589 10.5106 10.6113 10.7967 11.3983 10.7967C12.1853 10.7967 12.8292 10.439 13.4016 9.93821C13.9739 9.4374 14.2601 8.72195 14.2601 7.93496C14.2601 7.14797 13.9739 6.43252 13.4731 5.86016C12.9723 5.2878 12.2569 5.00163 11.4699 5.00163C10.826 5.00163 10.2536 5.21626 9.7528 5.57398C9.53817 5.71707 9.25199 5.71707 9.03736 5.50244C8.82272 5.2878 8.82272 4.93008 9.1089 4.71545C9.75281 4.28618 10.5398 4 11.3983 4Z"
      fill="#D2D2D3"
    />
  </svg>
);

export default SvgMixed;
